import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import locationServices from './services';
import locationActions from './actions';
import locationTypes from './types';

function* getLocationsListRequest(action) {
	try {
		let response = yield sagaCallService(
			locationServices.getLocationsList,
			action,
			action.payload
		);
		yield put(locationActions.locationsListSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, locationActions.locationsListFailure);
	}
}

function* getNeshanPositionRequest(action) {
	try {
		let response = yield sagaCallService(
			locationServices.getNeshanPosition,
			action,
			action.payload
		);
		yield put(locationActions.neshanPositionSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, locationActions.neshanPositionFailure);
	}
}

function* pointToAddressRequest(action) {
	try {
		let response = yield sagaCallService(
			locationServices.pointToAddress,
			action,
			action.payload
		);
		yield put(locationActions.pointToAddressSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, locationActions.pointToAddressFailure);
	}
}

const locationSagas = [
	takeEvery(locationTypes.LIST.REQUEST, getLocationsListRequest),
	takeEvery(locationTypes.NESHAN_POSITION.REQUEST, getNeshanPositionRequest),
	takeEvery(locationTypes.POINT_TO_ADDRESS.REQUEST, pointToAddressRequest),
];

export default locationSagas;
